import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import { withCookies, Cookies } from 'react-cookie';
import PropTypes, { instanceOf } from 'prop-types';
import classNames from 'classnames/bind';
import { COOKIE } from 'utils/defines';
import { iAmAdult as _iAmAdult } from 'redux/modules/info';
import ageCheck from 'assets/img/age-check.png';

const styles = isMobileOnly ? require('./assets/mobile.scss').default : require('./assets/desktop.scss').default;

const cx = classNames.bind(styles);

@connect(() => ({}), {
  iAmAdult: _iAmAdult,
})
@withCookies
class AreYouAdult extends PureComponent {
  static propTypes = {
    iAmAdult: PropTypes.func.isRequired,
    cookies: instanceOf(Cookies).isRequired,
  };

  state = {
    on: false,
  };

  componentDidMount() {
    if (window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.injected) {
      return;
    }
    const { iAmAdult, cookies } = this.props;
    const adult = cookies.get(COOKIE._ARE_YOU_ADULT) === 'true';
    if (adult) {
      iAmAdult();
    }
    this.setState({ on: !adult });
  }

  handleClickYes = () => {
    const { cookies, iAmAdult } = this.props;

    this.setState({ on: false });
    cookies.set(COOKIE._ARE_YOU_ADULT, true, { path: '/', maxAge: 31536000 });
    iAmAdult();
  };

  handleClickNo = () => {
    this.setState({ on: false });
  };

  render() {
    const { on } = this.state;

    return (
      <div className={cx('are-you-adult', { on })}>
        <div className={cx('are-you-adult-popup')}>
          <img src={ageCheck} alt="" />
          {!isMobileOnly ? <h2>Are you 18 or older?</h2> : <h3>Are you 18 or older?</h3>}
          <button type="button" className={cx('button', 'no', 'bold')} onClick={this.handleClickNo}>
            No
          </button>
          <button type="button" className={cx('button', 'yes', 'bold')} onClick={this.handleClickYes}>
            Yes
          </button>
        </div>
      </div>
    );
  }
}

export default AreYouAdult;
